import VitaButton from "./VitaButton.vue"
import VitaIcon from "./VitaIcon.vue"
import VitaInputVue from "./VitaInput.vue"
import VitaTooltip from "./VitaTooltip.vue"
import VitaMonthChanger from "./VitaMonthChanger.vue"
import VitaModal from "./VitaModal.vue"
import VitaLoader from "./VitaLoader.vue"

export default [
    VitaButton,
    VitaIcon,
    VitaTooltip,
    VitaInputVue,
    VitaMonthChanger,
    VitaModal,
    VitaLoader
]